import { combineReducers } from 'redux';
import loadingStateReducerFactory from '@nhl/loading-state-reducer-factory';

import actionTypes from './actionTypes';

/* State shape:
 {
     loadingState: {
         isLoading: bool
         success: bool
         errors: Array
     },
     menuState: {
         menuItems: Array
     }
 }
 */

const loadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_MENU_DATA)(actionTypes.MENU_DATA_RESPONSE);

const menuReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.MENU_DATA_RESPONSE:
            return action.payload.menu;
        default: return state;
    }
};

const menuStateReducer = combineReducers({
    menu: menuReducer
});

const reducer = combineReducers({
    loadingState: loadingStateReducer,
    menuState: menuStateReducer
});

export default reducer;
